import { app } from './Api';

const getDashboard = async () => {
    return app.get(`dashboard`);
};

export { getDashboard };
